//LIBARIES
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { TextField, RadioButtonGroup, SelectField, DatePicker } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import isEmpty from 'lodash/isEmpty';
import scrollIntoView from 'scroll-into-view';

//HELPERS
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as format from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';
import validate from '../validate';
import { getTranslatedString } from 'helpers/i18n';

//COMPONENTS
import AddressAutocomplete from 'components/shared/addressAutocomplete';
import { RenderGhostError } from 'components/shared/RenderError';
import countries from 'components/ui/Select/countries.json';

//CONSTANTS
import { CANADIAN_PROVINCES, USA_STATES } from 'constants/address.constants';
import { SALARY_RANGES } from 'constants/salaryranges.constants';

//STYLINGS
import 'components/tenant_app/components/tenant_profile/TenantProfile.css';

const style = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
  add_cotenant_button: {
    color: 'white',
  },
};

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
  ) : (
    false
  );

class WizardFormSeventhPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states_or_provinces: null,
    };
  }

  componentDidMount() {
    const country = this.props.country || deepDiver(this.props.initialValues, 'companyCountry');
    const countryObj =
      country && countries.filter((country) => country.name === this.props.country)[0];
    if (countryObj) {
      this.setStateOrProvinces(country);
      this.setState({ countryCode: countryObj.code });
    } else {
      this.props.change('companyUnit', '');
      this.props.change('companyStreet', '');
      this.props.change('companyCity', '');
      this.props.change('companyProvince', '');
      this.props.change('companyCountry', '');
      this.props.change('companyPostalCode', '');
    }
  }

  setStateOrProvinces = (country) => {
    let states_or_provinces;
    if (country === 'United States') {
      states_or_provinces = USA_STATES;
    } else if (country === 'Canada') {
      states_or_provinces = CANADIAN_PROVINCES;
    }

    this.setState({ states_or_provinces: states_or_provinces });
  };

  displayStatesOrProvinces = () => {
    if (!this.state.states_or_provinces) return null;

    return this.state.states_or_provinces.map((item, index) => {
      return <MenuItem key={index} value={item} primaryText={item} />;
    });
  };

  /**
   * update country state when autocomplete is selected
   * @function getAddressFromAutoComplete
   * @param { address } string - passed down from autocomplete
   */
  getAddressFromAutoComplete = (address) => {
    if (!isEmpty(address)) {
      this.setStateOrProvinces(address.country);
    }
  };

  render() {
    const { handleSubmit, previousPage } = this.props;

    const addToAddressFields = (street, city, province, country, post_code) => {
      this.props.change('companyStreet', street);
      this.props.change('companyCity', city);
      this.props.change('companyProvince', province);
      this.props.change('companyCountry', country);
      this.props.change('companyPostalCode', post_code);
      this.setStateOrProvinces(country);
    };

    return (
      <div>
        <form onSubmit={handleSubmit.bind(this)}>
          {this.props.isCurrentlyAStudent && (
            <div id="top" style={{ marginTop: '50px' }}>
              <h3
                style={{
                  fontSize: '30px',
                  marginBottom: '20px',
                  fontFamily: 'Circular-Bold',
                }}
              >
                Where are you currently going to school?
              </h3>
              <div className="row" style={{ marginBottom: '70px' }}>
                <div className="row">
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="university"
                      type="text"
                      component={TextField}
                      floatingLabelText="University/College"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    />
                    <Field name="university" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="fieldOfStudy"
                      type="text"
                      component={TextField}
                      floatingLabelText="Field of Study"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    />
                    <Field name="fieldOfStudy" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="universityCity"
                      type="text"
                      component={TextField}
                      floatingLabelText="City"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    />
                    <Field name="universityCity" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="universityCountry"
                      type="text"
                      component={TextField}
                      floatingLabelText="Country"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    />
                    <Field name="universityCountry" component={RenderGhostError} />
                  </div>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                  <h5
                    style={{
                      textAlign: 'center',
                      marginBottom: '20px',
                      fontSize: '18px',
                    }}
                  >
                    Graduation Year
                  </h5>
                  <Field
                    name="graduatingYear"
                    component={RadioButtonGroup}
                    style={{
                      maxWidth: '500px',
                      margin: 'auto',
                    }}
                  >
                    <RadioButton
                      value={`${new Date().getFullYear()}`}
                      label={`${new Date().getFullYear()}`}
                      style={{ width: '102px', display: 'inline-flex' }}
                    />
                    <RadioButton
                      value={`${new Date().getFullYear() + 1}`}
                      label={`${new Date().getFullYear() + 1}`}
                      style={{ width: '102px', display: 'inline-flex' }}
                    />
                    <RadioButton
                      value={`${new Date().getFullYear() + 2}`}
                      label={`${new Date().getFullYear() + 2}`}
                      style={{ width: '102px', display: 'inline-flex' }}
                    />
                    <RadioButton
                      value={`${new Date().getFullYear() + 3}`}
                      label={`${new Date().getFullYear() + 3}`}
                      style={{ width: '102px', display: 'inline-flex' }}
                    />
                    <RadioButton
                      value={`${new Date().getFullYear() + 4}+`}
                      label={`${new Date().getFullYear() + 4}+`}
                      style={{ width: '86px', display: 'inline-flex' }}
                    />
                    <RadioButton
                      value="Other"
                      label="Other"
                      style={{ width: '86px', display: 'inline-flex' }}
                    />
                  </Field>
                  <Field name="graduatingYear" component={renderError} />
                </div>
              </div>
            </div>
          )}
          {!this.props.isCurrentlyAStudent && (
            <div id="top" style={{ marginTop: '50px' }}>
              <h3
                style={{
                  textAlign: 'center',
                  fontSize: '30px',
                  marginBottom: '20px',
                  fontFamily: 'Circular-Bold',
                }}
              >
                Where are you currently working?
              </h3>
              <div className="row" style={{ marginBottom: '70px' }}>
                <div className="row">
                  <div className="row" style={{ marginBottom: '20px' }}>
                    <div className="col-sm-6" style={{ textAlign: 'center' }}>
                      <Field
                        name="occupation"
                        type="text"
                        component={TextField}
                        floatingLabelText="Occupation"
                        style={{
                          marginTop: '-15px',
                          fontSize: '14px',
                          width: '100%',
                        }}
                        errorStyle={{ fontSize: '14px' }}
                      />
                      <Field name={`occupation`} component={RenderGhostError} />
                    </div>
                    <div className="col-sm-6" style={{ textAlign: 'center' }}>
                      <Field
                        name="companyName"
                        type="text"
                        component={TextField}
                        floatingLabelText="Company Name"
                        style={{
                          marginTop: '-15px',
                          fontSize: '14px',
                          width: '100%',
                        }}
                        errorStyle={{ fontSize: '14px' }}
                      />
                      <Field name="companyName" component={RenderGhostError} />
                    </div>
                  </div>
                  <h5
                    style={{
                      textAlign: 'center',
                      marginBottom: '0px',
                      marginTop: '10px',
                      fontSize: '18px',
                    }}
                  >
                    Company Address
                  </h5>
                  <div className="col-xs-4" style={{ textAlign: 'center', zIndex: '1000' }}>
                    <Field
                      name="companyUnit"
                      type="text"
                      component={TextField}
                      floatingLabelText="Unit"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                    />
                    <Field name="companyUnit" component={RenderGhostError} />
                  </div>
                  <div className="col-xs-8" style={{ textAlign: 'center', zIndex: '1000' }}>
                    <AddressAutocomplete
                      addToRedux={addToAddressFields}
                      floatingLabelText="Address"
                      getAddressFromAutoComplete={this.getAddressFromAutoComplete}
                      name="companyStreet"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                      streetAddress={this.props.streetAddress}
                      countryCode={this.state.countryCode}
                    />
                    <Field name="companyStreet" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="companyCity"
                      type="text"
                      component={TextField}
                      floatingLabelText="City"
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    />
                    <Field name="companyCity" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    {['United States', 'Canada'].includes(this.props.country) ? (
                      <Field
                        name="companyProvince"
                        component={SelectField}
                        floatingLabelText={this.props.country === 'Canada' ? 'Province' : 'State'}
                        style={{
                          marginTop: '-15px',
                          fontSize: '14px',
                          textAlign: 'left',
                          width: '100%',
                        }}
                        errorStyle={{ fontSize: '14px' }}
                      >
                        {this.displayStatesOrProvinces()}
                      </Field>
                    ) : (
                      <Field
                        name="companyProvince"
                        type="text"
                        component={TextField}
                        floatingLabelText={getTranslatedString('addressForm.division')}
                        style={{
                          marginTop: '-15px',
                          fontSize: '14px',
                          width: '100%',
                        }}
                        errorStyle={{ fontSize: '14px' }}
                      />
                    )}
                    <Field name="companyProvince" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="companyPostalCode"
                      type="text"
                      component={TextField}
                      floatingLabelText={getTranslatedString('addressForm.area')}
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                    />
                    <Field name="companyPostalCode" component={RenderGhostError} />
                  </div>
                  <div className="col-sm-6" style={{ textAlign: 'center' }}>
                    <Field
                      name="companyCountry"
                      type="text"
                      component={SelectField}
                      floatingLabelText="Country"
                      onChange={(e, value) => {
                        this.props.change('companyProvince', null);
                        this.setStateOrProvinces(value);
                      }}
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        textAlign: 'left',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    >
                      {countries.map((country) => (
                        <MenuItem
                          key={`country_${country.code}`}
                          value={country.name}
                          primaryText={country.name}
                        />
                      ))}
                    </Field>
                    <Field name="companyCountry" component={RenderGhostError} />
                  </div>
                </div>

                <div className="row" style={{ marginTop: '20px' }}>
                  <h5
                    style={{
                      textAlign: 'center',
                      marginBottom: '0px',
                      fontSize: '18px',
                    }}
                  >
                    {getTranslatedString('yearlyIncome')}
                  </h5>
                  <div className="col-sm-3" />
                  <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                    <Field
                      name="yearlySalary"
                      component={SelectField}
                      hintText={getTranslatedString('yearlyIncome')}
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        textAlign: 'left',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                    >
                      {SALARY_RANGES.map((range) => (
                        <MenuItem value={range.value} primaryText={range.primaryText} />
                      ))}
                    </Field>
                    <Field name="yearlySalary" component={RenderGhostError} />
                  </div>
                </div>

                <div className="row" style={{ marginTop: '10px' }}>
                  <h5
                    style={{
                      textAlign: 'center',
                      marginBottom: '0px',
                      fontSize: '18px',
                    }}
                  >
                    Start Date
                  </h5>
                  <div className="col-sm-3" />
                  <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '10px' }}>
                    <Field
                      name="startDate"
                      component={DatePicker}
                      openToYearSelection={true}
                      hintText="When did you start working here?"
                      maxDate={new Date()}
                      style={{
                        marginTop: '-15px',
                        fontSize: '14px',
                        width: '100%',
                      }}
                      errorStyle={{ fontSize: '14px' }}
                      formatDate={format.reformatDate}
                      autoOk={true}
                      hintStyle={{ fontSize: '14px' }}
                    />
                    <Field name="startDate" component={RenderGhostError} />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row" style={{ marginTop: '75px' }} />
          <div id="application_footerbar">
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
              <FlatButton
                label="Back"
                type="button"
                className="previous"
                onClick={previousPage}
                backgroundColor="#fff"
                hoverColor="grey"
                style={style.backButton}
              />
              <FlatButton
                label="Next"
                type="submit"
                className="next"
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.button}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

WizardFormSeventhPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(WizardFormSeventhPage);

const selector = formValueSelector('wizard');
WizardFormSeventhPage = connect((state) => {
  const streetAddress = selector(state, 'companyStreet');
  const country = selector(state, 'companyCountry');
  return {
    isCurrentlyAStudent: state.tenantApplication.isStudent,
    initialValues: state.tenantApplication.tenantApplication,
    streetAddress,
    country,
  };
})(WizardFormSeventhPage);

export default WizardFormSeventhPage;
